import { appRoutes } from "../../../constants/appRoutes";

export const galleryRoute = {
  path: appRoutes.gallery.path,
  lazy: () => import("../../../pages/Gallery")
};
